/* eslint-disable */
import * as Yup from 'yup';
import kycFormModel from './kycFormModel';
const {
  formField: {
    white_label_logo,
    wl_primarycolor,
    n_fontcolor,
    lab_primary,
    lab_fontcolor,
    theme,
  }
} = kycFormModel;

export default function validationSchemaEditTax(){
  return[
  Yup.object().shape({
    [white_label_logo.name]: Yup.string().required(`${white_label_logo.requiredErrorMsg}`),
    [wl_primarycolor.name]: Yup.string().required(`${wl_primarycolor.requiredErrorMsg}`),
    [n_fontcolor.name]: Yup.string().required(`${n_fontcolor.requiredErrorMsg}`),
    [lab_primary.name]: Yup.string().required(`${lab_primary.requiredErrorMsg}`),
    [lab_fontcolor.name]: Yup.string().required(`${lab_fontcolor.requiredErrorMsg}`),
    [theme.name]: Yup.string().required(`${theme.requiredErrorMsg}`),
  }),
]
};
